const resource = {
    resource_identifier_in_use: "L'identificatore API {{indicator}} è già in uso",
};
export default resource;
